import Global from "./Global";

const GlobalConfig = {
    // 页面标题
    title : '',
    // 接口路径
    apiUrl:window.location.origin+'/api/',/*http://mw.skyqlm.com/*/
    imgUrl:/*window.location.origin+*//*'http://mw.skycdu.com/uploads/'*/'',
    logoUrl:window.location.origin+'/uploads/logo/myanmar.png',
    faceUrl:'',
    //接口限制请求
    apimenutitle:false,
    //apiUrl:'/api?',
    // 接口后缀
    suffixUrl:'r=api/default/',
    // 标题
    appTitle : {

    },


};
//
export default GlobalConfig;



// WEBPACK FOOTER //
// ./src/assets/js/config.file.js